import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

type CompressImageOptions = {
  maxWidth?: number;
  maxHeight?: number;
  quality?: number;
};

export function compressImage(file: File, options: CompressImageOptions = {}): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target?.result as string;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const maxWidth = options.maxWidth ?? 1200;
        const maxHeight = options.maxHeight ?? 1200;
        let width = img.width;
        let height = img.height;

        if (width > height) {
          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
          }
        }
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          resolve(event.target?.result as string);
          return;
        }
        ctx.drawImage(img, 0, 0, width, height);
        const compressedBase64 = canvas.toDataURL('image/jpeg', options.quality ?? 0.8);
        resolve(compressedBase64);
      };
      img.onerror = () => {
        reject(new Error("Erreur lors du chargement de l'image"));
      };
    };
    reader.onerror = (err) => {
      reject(err);
    };
  });
}
